module.exports = "/lucky-balls/img/infobox/info_Box_021.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_021.png
// module id = 1086
// module chunks = 0